import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import { localeStrings as strings } from 'applicationConfig';
import ActionLink from 'common/components/ActionLink/ActionLink';
import paths from '../../common/constants/paths';
import bestExecutionImage from 'src/common/images/best-execution.jpg';
import transparencyDataImage from 'src/common/images/transparency-data.jpg';
import './home.scss';

class Home extends Component {
  render() {
    const blocks = [
      { text: strings.home.bestExecutionReports, image: bestExecutionImage, to: paths.reporting },
      { text: strings.home.transparencyData, image: transparencyDataImage, to: paths.transparencyData }
    ];
    return (
      <div className="home-page">
        <div className="home-page-body">
          {blocks.map((block, index) => (
            <div className="home-page-block" key={index}>
              <h3 className="block-header">{block.text}</h3>
              <div className="block-image">
                <Link to={block.to}>
                  <img src={block.image} alt={block.text} />
                </Link>
              </div>
              <p className="block-link-container">
                <ActionLink to={block.to}>
                  <span>{strings.home.clickHereFor} </span>
                  <b>{block.text}</b>
                </ActionLink>
              </p>
            </div>
          ))}
        </div>
      </div>
    );
  }
}
export default Home;



// WEBPACK FOOTER //
// ./src/containers/Home/Home.jsx